import { render, staticRenderFns } from "./CheckEditor.vue?vue&type=template&id=72671173"
import script from "./CheckEditor.vue?vue&type=script&lang=js"
export * from "./CheckEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports